(function () {
'use strict';
var SENTINEL_SELECTOR = '[data-infinite-scroll-sentinel]';
var NEXT_SELECTOR = '[data-infinite-scroll-next]';
var LOADING_SELECTOR = '[data-infinite-scroll-loading]';
var initialized = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
function setup(sentinel) {
if (initialized) {
if (initialized.has(sentinel)) return;
initialized.add(sentinel);
}
var gridSelector = sentinel.getAttribute('data-grid-selector') || '#CollectionLoop';
var sectionId = sentinel.getAttribute('data-section-id');
var grid = document.querySelector(gridSelector);
if (!grid || !sectionId) return;
var loading = false;
var loadingEl = document.querySelector(LOADING_SELECTOR);
function getNextUrl() {
var marker = document.querySelector(NEXT_SELECTOR);
return marker ? marker.getAttribute('data-url') : null;
}
function toggleLoading(show) {
if (loadingEl) loadingEl.style.display = show ? '' : 'none';
}
function loadNextPage() {
var nextUrl = getNextUrl();
if (!nextUrl || loading) return;
loading = true;
toggleLoading(true);
var sep = nextUrl.indexOf('?') > -1 ? '&' : '?';
var fetchUrl = nextUrl + sep + 'section_id=' + encodeURIComponent(sectionId);
fetch(fetchUrl, { credentials: 'same-origin' })
.then(function (res) {
if (!res.ok) throw new Error('Pedido falhou: ' + res.status);
return res.text();
})
.then(function (html) {
var doc = new DOMParser().parseFromString(html, 'text/html');
var newGrid = doc.querySelector(gridSelector);
var newMarker = doc.querySelector(NEXT_SELECTOR);
var oldMarker = document.querySelector(NEXT_SELECTOR);
if (newGrid) {
while (newGrid.firstChild) {
grid.appendChild(newGrid.firstChild);
}
}
if (oldMarker) oldMarker.remove();
if (newMarker) {
sentinel.parentNode.insertBefore(newMarker, sentinel);
}
document.dispatchEvent(
new CustomEvent('infinite-scroll:loaded', { detail: { sectionId: sectionId } })
);
loading = false;
toggleLoading(false);
if (!newMarker) {
observer.unobserve(sentinel);
}
})
.catch(function (err) {
console.error('[infinite-scroll]', err);
loading = false;
toggleLoading(false);
});
}
var observer = new IntersectionObserver(
function (entries) {
entries.forEach(function (entry) {
if (entry.isIntersecting) loadNextPage();
});
},
{ rootMargin: '800px 0px 800px 0px' }
);
observer.observe(sentinel);
}
function scan(root) {
(root || document).querySelectorAll(SENTINEL_SELECTOR).forEach(setup);
}
function boot() {
scan(document);
var bodyObserver = new MutationObserver(function () {
scan(document);
});
bodyObserver.observe(document.body, { childList: true, subtree: true });
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', boot);
} else {
boot();
}
window.ShopifyInfiniteScroll = { scan: scan };
})();
